
import Vue from 'vue';
import Component from 'vue-class-component';
import { getModule } from 'vuex-module-decorators';
import GlobalStore from '@/store/modules/global';
import { addressRequired, addressValid } from '@/validate';
import { Auth } from '@aws-amplify/auth';
// Define the component in class-style
@Component({ name: 'About' })
export default class About extends Vue {
  public globalStore = getModule(GlobalStore, this.$store);
  flightPathIp: string | null = null;
  valid = false;
  localMode = false;
  signedIn = false;

  // Class properties will be component data

  addressRules: ((data: string) => void)[] = [addressRequired(), addressValid()];

  signOut() {
    Auth.signOut();
  }

  submit() {
    localStorage.flightPathIp = this.flightPathIp;
    localStorage.localMode = this.localMode;
  }
  beforeCreate() {
    Auth.currentAuthenticatedUser()
      .then((user) => {
        if (user != undefined) {
          this.signedIn = true;
        }
      })
      .catch(() => console.log('not signed in...'));
  }

  get currentAccountId() {
    return this.globalStore.accountId;
  }
  mounted() {
    if (localStorage.flightPathIp) {
      this.flightPathIp = localStorage.flightPathIp;
    }
    //todo move this into vuex
    if (localStorage.localMode) {
      this.localMode = localStorage.localMode == 'true';
    }
  }

  // props will be calculated properties
  get appVersion(): string | undefined {
    return this.globalStore.version;
  }
}
